import React, { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";

const createColumnDefs = () => {
  return [
    {
      headerName: "Date",
      field: "createdAt",
      width: 15,
    },
    {
      headerName: "Driver 1",
      field: "driver1_name",
      width: 15,
    },
    {
      headerName: "Driver 2",
      field: "driver2_name",
      width: 15,
    },
    {
      headerName: "Comments",
      field: "comment",
      width: 55,
      cellClass: "cell-wrap-text",
      autoHeight: true
    },
  ];
};

const LocationReport = (props) => {
  // State
  const [columnDefs] = useState(createColumnDefs());
  const [driverCommentList, setDriverCommentList] = useState([]);
  
  // Refs for grid API
  const gridApiRef = useRef(null);
  const columnApiRef = useRef(null);

  // Update state when props change
  useEffect(() => {
    if (props.driverCommentList && props.driverCommentList.length > 0) {
      setDriverCommentList(props.driverCommentList);
    }
  }, [props.driverCommentList]);

  // Grid ready handler
  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    columnApiRef.current = params.columnApi;
    gridApiRef.current.sizeColumnsToFit();
  };

  return (
    <div style={{ height: "460px" }} className={"ag-theme-quartz"}>
      <AgGridReact
        // properties
        columnDefs={columnDefs}
        rowData={driverCommentList}
        // events
        onGridReady={onGridReady}
        enableColResize
        enableSorting
        enableFilter
      />
    </div>
  );
};

export default LocationReport;
